import { Logger } from '../utils/logger';
import { FileWriter } from '../utils/file-writer';
import { runCommand } from '../utils/command-runner';
import { adds } from '../configs/jasmine-test-config';
import { getRelativePath } from '../utils/relative-path';

/**
 * The upgrader for the jamine test files(.spec.ts files)
 */
export class JasmineTestUpgrader {
    private fileWriter: FileWriter;
    private testTsFilePath: string;
    private debug = false;

    private messages = {
        notFound: ''
    };

    /**
     * the constructor.
     * @param filePath the file path.
     */
    constructor(testTsFilePath: string, debug = false) {
        this.messages.notFound = `No spec.ts file found.`;
        this.testTsFilePath = testTsFilePath;
        this.debug = debug;
    }

    /**
     * the run function to resolve the errors.
     */
    public async run(): Promise<void> {
        try {
            const getSpecFiles = 'dir /s /b src\\*.spec.ts';
            let specFiles = [];
            Logger.log(getSpecFiles);
            runCommand(getSpecFiles, this.debug, true).then(async (response) => {
                specFiles = response.split('\r\n');

                if (!specFiles.length) {
                    Logger.log(this.messages.notFound);
                }

                specFiles = specFiles.filter(item => item.trim() !== "");
                console.log(specFiles);
                console.log(specFiles.length);

                for (let i = 0; i < specFiles.length; i++) {
                    const specFile = specFiles[i];

                    // Wait for 50ms
                    await sleep(50);
                    
                    this.fileWriter = new FileWriter(specFile);

                    this.fileWriter
                        .addContent(adds, false, 0, '')
                        .fixImportHandler(`import { setUpMock } from "${getRelativePath(specFile, this.testTsFilePath).replace('.ts', '')}";`)
                        .writeFile();
                }

                /**
                 * This function guarantees that MIMO on file system is not triggering race condition.
                 * @param ms miliseconds
                 * @returns 
                 */
                function sleep(ms) {
                    return new Promise(resolve => setTimeout(resolve, ms));
                }
            });

        } catch (error) {
            Logger.error(error);
        }
    }
}
